/**
 * BTS Share Helper — แชร์ invite link ผ่าน LINE
 */

export const btsShareHelper = {
  smartShare: (partyCode, shareUrl) => {
    const displayName = localStorage.getItem('line_display_name') || 'เพื่อน';

    const message = `🏫 Back to School บิลรู้ใจคุณ : เปิดเทอมใหญ่ หัวใจว้าวุ่น!

🏆 ชวนกันมารวมทีม สแกนบิลสะสมคะแนน แล้วไปลุ้นกินไก่ฟรีตลอดปีด้วยกัน!

${displayName} - ชวนคุณมาร่วมทีม!

👉 กดเข้าร่วมเลย: ${shareUrl}`;

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      const encoded = encodeURIComponent(message);
      window.location.href = `line://msg/text/${encoded}`;
      return { success: true, method: 'line_app' };
    }

    // Desktop: LINE Social Plugins
    const encoded = encodeURIComponent(message);
    const lineShareUrl = `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(shareUrl)}&text=${encoded}`;

    const shareWindow = window.open(lineShareUrl, '_blank', 'width=600,height=800');
    if (!shareWindow) {
      window.location.href = lineShareUrl;
      return { success: true, method: 'redirect' };
    }
    return { success: true, method: 'popup' };
  },
};

export default btsShareHelper;
